var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "selectOperator", staticClass: "selectOperator" }, [
    _c("div", { staticClass: "select__body" }, [
      _c(
        "span",
        {
          directives: [{ name: "translate", rawName: "v-translate" }],
          attrs: {
            tabindex: "0",
            "aria-live": "assertive",
            title: _vm.$gettext("Instrucciones para seleccionar agente"),
          },
        },
        [_vm._v(_vm._s(_vm.$gettext("selecciona un agente disponible")))]
      ),
      _vm.operators.length > 0
        ? _c(
            "ul",
            {
              staticClass: "operators-list",
              staticStyle: { "list-style": "none" },
            },
            _vm._l(_vm.operators, function (operator) {
              return _c(
                "li",
                { key: operator.operatorid, staticClass: "operator-item" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "operator",
                      attrs: {
                        title:
                          _vm.$gettext("Seleccionar agente") +
                          " " +
                          operator.name,
                      },
                      on: {
                        click: function ($event) {
                          operator.status.id == 0 &&
                            _vm.chooseOperator(operator.operatorid)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "operator__img" }, [
                        operator.vcavatar &&
                        _vm.avatarsStatus[operator.operatorid]
                          ? _c("img", {
                              staticClass: "image",
                              attrs: {
                                tabindex: "-1",
                                src: operator.vcavatar,
                                alt:
                                  _vm.$gettext("Foto del agente") +
                                  " " +
                                  operator.name,
                              },
                            })
                          : _c("div", { staticClass: "agent__initial" }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(operator && operator.name.charAt(0))
                                ),
                              ]),
                            ]),
                        _c("div", {
                          staticClass: "status-indicator",
                          class:
                            _vm.options.operator[operator.status?.id].status,
                          attrs: {
                            "aria-label":
                              _vm.options.operator[operator.status?.id]
                                .translation,
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "operator-name" }, [
                        _vm._v(_vm._s(operator.name)),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flags-container" },
                        _vm._l(operator.vcelanguage, function (language) {
                          return _c("img", {
                            staticClass: "flag",
                            attrs: {
                              src: require(`@/assets/flags/${language}.svg`),
                              alt: _vm.options.language[language].translation,
                            },
                          })
                        }),
                        0
                      ),
                      _c("div", {
                        staticClass: "call-icon",
                        class:
                          _vm.options.camera[
                            parseInt(operator.available_camera)
                          ].class,
                        attrs: {
                          "aria-label":
                            _vm.options.camera[
                              parseInt(operator.available_camera)
                            ].translation,
                        },
                      }),
                    ]
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]),
    _c("div", { staticClass: "select__random" }, [
      _c(
        "button",
        {
          attrs: { title: _vm.$gettext("Acceder al formulario de contacto") },
          on: { click: _vm.offlineForm },
        },
        [_vm._v(_vm._s(_vm.$gettext("Formulario de contacto")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }